import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

export const CommonQualificationsCrumbs: Array<BreadcrumbItem> = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Qualifiche',
    path: '/sistema/qualifiche',
  },
];
